import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Auth } from "../../Contexts/AuthContext";

const Topbar = () => {
  const { auth, logOut } = useContext(Auth);
  const location = useLocation();
  const handleLogout = () => {
    logOut();
  }
  const checkCurrentRoute = (routeName) => {
    if (location?.pathname === routeName)
      return 'text-[#178ACB]';
    else
      return 'text-[#878787]'
  }



  return (

    <>
      {
        auth?.token ? (
          <div className="bg-[#FFF9F6] h-16  items-center justify-center  hidden lg:flex font-museo border-b-2 " >
            {auth?.userRole === "BRAND" ? (
              <>
                <Link to="/my-campaigns" className={`mr-8  ${checkCurrentRoute('/my-campaigns')} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>My Campaigns</Link>
                <div className='bg-gray-500 mr-8 w-[2px] h-5 ' ></div>
                <Link to="/tasks" className={`mr-8  ${checkCurrentRoute('/tasks')} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>My Tasks</Link>
                <div className='bg-gray-500 mr-8 w-[2px] h-5 ' ></div>
                <Link to="" onClick={handleLogout} className={`mr-8  font-museobb ${checkCurrentRoute('/logOut')} focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>Logout</Link>
              </>
            ) : (
              <>
                <Link to="/campaigns" className={`mr-8 ${checkCurrentRoute('/campaigns')} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>Campaigns</Link>
                <div className='bg-gray-500 mr-8 w-[2px] h-5 ' ></div>
                <Link to="/my-posts" className={`mr-8 ${checkCurrentRoute('/my-posts')} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>My Posts</Link>
                <div className='bg-gray-500 mr-8 w-[2px] h-5' ></div>
                <Link to="/my-payouts" className={`mr-8 ${checkCurrentRoute('/my-payouts')} font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>Payouts</Link>
                <div className='bg-gray-500 w-[2px] h-5 mr-8' ></div>
                <Link to="/CamRequest " className={`mr-8 ${checkCurrentRoute('/cam_li')}  font-museobb focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>Reports</Link>
                <div className='bg-gray-500 w-[2px] h-5 mr-8' ></div>
                <Link to="" onClick={handleLogout} className={`mr-8  font-museobb ${checkCurrentRoute('/logOut')} focus:text-[#178ACB] focus:no-underline hover:no-underline hover:text-[#878787]`}>Logout</Link>
              </>
            )}
          </div >
        ) : <></>}

    </>




  );
};

export default Topbar;
